var $d10d6b60dc50b438$exports = {};
$d10d6b60dc50b438$exports = {
    "alpha": `Alfa`,
    "blue": `Zila`,
    "brightness": `Spilgtums`,
    "green": `Za\u{13C}a`,
    "hue": `Nokr\u{101}sa`,
    "lightness": `Gai\u{161}ums`,
    "red": `Sarkana`,
    "saturation": `Pies\u{101}tin\u{101}jums`
};


export {$d10d6b60dc50b438$exports as default};
//# sourceMappingURL=lv-LV.module.js.map
